import * as yup from "yup";
import { validationSchemas } from "./data";
export const backScreenSchema = yup.object().shape({
  nameSlider: validationSchemas.name,
  selectSize: validationSchemas.numberSelect,
});
